<div class="tooltip" [class.active]="active">
	{{message}}
</div>
